/**
 * Client diary + carrier task APIs expect numeric ADA / leave filter keys.
 * `claim.recordId` in the SPA is often the encrypted route token — do not send that as ADA/leave (325562).
 */
export function numericAdaOrLeaveKeyFromClaim(claim: {
  claimNumber?: string;
  fileNumber?: string;
  recordId?: unknown;
}): number | null {
  const digitsOnly = (v: unknown): number | null => {
    if (v === undefined || v === null || v === '') {
      return null;
    }
    if (typeof v === 'object' && v !== null && 'value' in v) {
      return digitsOnly((v as { value: unknown }).value);
    }
    const s = String(v).trim();
    if (!/^\d+$/.test(s)) {
      return null;
    }
    const n = parseInt(s, 10);
    return Number.isFinite(n) ? n : null;
  };
  return (
    digitsOnly(claim?.claimNumber) ??
    digitsOnly(claim?.fileNumber) ??
    digitsOnly(claim?.recordId)
  );
}
